var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2002 16.6666C4.2002 15.535 4.64972 14.4497 5.44987 13.6496C6.25003 12.8494 7.33527 12.3999 8.46686 12.3999H17.0002C18.1318 12.3999 19.217 12.8494 20.0172 13.6496C20.8173 14.4497 21.2669 15.535 21.2669 16.6666C21.2669 17.2324 21.0421 17.775 20.642 18.1751C20.2419 18.5751 19.6993 18.7999 19.1335 18.7999H6.33353C5.76773 18.7999 5.22511 18.5751 4.82503 18.1751C4.42496 17.775 4.2002 17.2324 4.2002 16.6666Z",
    stroke: "#192BC2",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 10.6666C14.7676 10.6666 16.2003 9.23391 16.2003 7.4666C16.2003 5.69929 14.7676 4.2666 13.0003 4.2666C11.233 4.2666 9.80029 5.69929 9.80029 7.4666C9.80029 9.23391 11.233 10.6666 13.0003 10.6666Z",
    stroke: "#192BC2",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.668df59dab85b1498cd0c29e5215d5c6.svg";
export { ForwardRef as ReactComponent };